import { render, staticRenderFns } from "./NewDate.vue?vue&type=template&id=a284e8d4&scoped=true"
import script from "./NewDate.vue?vue&type=script&lang=ts"
export * from "./NewDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a284e8d4",
  null
  
)

export default component.exports